export default __webpack_public_path__ + "static/tagesfahrt-475b702372e8fb91376d4dd1bd00fb98.png";